import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodyXSBoldText from 'shared/components/vxl/typography/primary/body/BodyXSBoldText';
import theme from 'shared/styles/theme';

export interface BadgeProps {
  badgeValue: number;
  labelText?: string;
}

function Badge({ badgeValue, labelText }: BadgeProps) {
  return (
    <View style={styles.mainView}>
      {badgeValue > 0 ? (
        <>
          {labelText ? (
            <BodyBaseText numberOfLines={1} ellipsizeMode="tail">
              {labelText}
            </BodyBaseText>
          ) : null}
          <View style={styles.circularView}>
            <BodyXSBoldText style={styles.badgeText}>
              {capBadgeCount(badgeValue)}
            </BodyXSBoldText>
          </View>
        </>
      ) : null}
    </View>
  );
}

const capBadgeCount = (badgeValue: number) => {
  const maxValueText = '99+';
  return badgeValue > 99 ? maxValueText : badgeValue;
};

const styles = StyleSheet.create({
  badgeText: {
    color: theme.color.text.inverse,
    paddingHorizontal: theme.spacing.s,
  },
  circularView: {
    alignItems: 'center',
    backgroundColor: theme.color.status.negative,
    borderRadius: theme.spacing.l,
    justifyContent: 'center',
    minHeight: theme.spacing.l,
    minWidth: theme.spacing.l,
  },
  mainView: {
    alignItems: 'center',
    flexDirection: 'row',
    flexShrink: 1,
    gap: theme.spacing.s,
  },
});

export default Badge;
